import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingHeader } from '../../../shared/components/layout/LandingHeader';
import { SpecialLine } from '../../../shared/components/layout/SpecialLine';
import { SEO } from '../../../shared/components/SEO/SEO';
import { Footer } from '../../../shared/components/layout/Footer';
import landingHeroBg from '../../../assets/images/landing-hero-bg.png';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div 
      className="min-h-screen bg-cover bg-center flex flex-col"
      style={{ backgroundImage: `url(${landingHeroBg})` }}
    >
      <SEO />
      <LandingHeader color="#FFFFFF" />

      {/* Main Content */}
      <div className="flex-grow max-w-4xl mx-auto px-4 pt-[10vh]">
        <div className="text-center mb-8">
          <SpecialLine text="The most powerful Bible app" className="mb-8" color="white" />
          <h1 className="text-5xl sm:text-7xl font-newsreader font-bold text-white">
            Never walk alone again
          </h1>
          <p className="mt-2 text-xl sm:text-4xl px-24 text-white font-newsreader font-light leading-[1.5]">
            Get instant answers to life's most pressing questions directly from the bible
          </p>
        </div>

        <div className="flex flex-col items-center space-y-8">
          <button
            onClick={() => navigate('/login')}
            className="px-32 py-3 bg-white text-[#361E06] rounded-full text-lg font-semibold hover:bg-[rgba(255,255,255,0.9)] transition-colors"
          >
            Start chatting
          </button>

          <div className="flex items-center space-x-4 font-bold">
            <a href="#" className="text-white hover:underline">Google Play</a>
            <span className="text-white">•</span>
            <a href="#" className="text-white hover:underline">App Store</a>
          </div>
        </div>
      </div>

      <Footer variant="light" />
    </div>
  );
}
